import { render, staticRenderFns } from "./section-create.vue?vue&type=template&id=4ba39565"
import script from "./section-create.vue?vue&type=script&lang=js"
export * from "./section-create.vue?vue&type=script&lang=js"
import style0 from "./section-create.vue?vue&type=style&index=0&id=4ba39565&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports